import { makeStyles } from '@material-ui/core/styles';

export const useStyles = makeStyles(({ spacing, themeName, mlbCustomVariables, typography }) => ({
  title: {
    textAlign: 'center',
    margin: spacing(5, 0),
    ...(themeName === 'dacia' && {
      ...typography.h1,
      fontFamily: mlbCustomVariables.primaryFont,
      textTransform: 'uppercase'
    })
  }
}));
